import React, { useCallback, useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { useHistory } from 'react-router-dom';

import { AppState } from '../../store';

import { fetchPrescription as fetchPrescriptionAction } from '../../store/prescription/actions';

import Search from './Search';

import { ToastProvider, useToast } from '../../components/ui/Toast';

import { PrescriptionError } from '../../store/prescription/types';

interface StateProps {
  error: PrescriptionError;
}

interface DispatchProps {
  fetchPrescription: Function;
}

type Props = StateProps & DispatchProps;

const validateToken = (token: string): string => {
  if (token.indexOf('/receita') === -1 && token.length <= 7) return token;

  const formattedToken = token.split('/').pop() || '';

  return formattedToken.length === 6 || formattedToken.length === 7 ? formattedToken : '';
};

const SearchContainer: React.FC<Props> = ({ error, fetchPrescription }: Props) => {
  /*
   * Hooks
   */
  const [prescriptionToken, setPrescriptionToken] = useState('');

  const history = useHistory();

  const { addToast } = useToast();

  //
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setPrescriptionToken(validateToken(event.currentTarget.value));
  };

  //
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();

    if (prescriptionToken.length < 1) return;

    const prescriptionResponse = await fetchPrescription(prescriptionToken);

    if (prescriptionResponse) {
      history.push(prescriptionToken);
    }
  };

  //
  const handleError = useCallback((statusCode: number) => {
    switch (statusCode) {
      case 401: {
        addToast({
          title: 'Ação necessária',
          description: `Ocorreu um erro no sistema devido uma atualização cadastral. Faça o logoff
            da conta e entre novamente. Caso o erro permaneça, entre em contato com a equipe técnica.`,
          status: 'danger',
        });

        return;
      }

      case 404: {
        addToast({
          title: 'Atenção',
          description: 'A receita foi editada ou apagada pelo médico.',
          status: 'danger',
        });

        return;
      }

      default: {
        addToast({
          title: 'Atenção',
          description: 'O Código da receita não existe, verifique se foi digitado corretamente.',
          status: 'danger',
        });
      }
    }
  }, [addToast]);

  //
  useEffect(() => {
    if (error.exists) {
      handleError(error.status);
    }
  }, [error, handleError]);

  return <Search value={prescriptionToken} onChange={handleChange} onSubmit={handleSubmit} />;
};

const SearchContainerWithToast: React.FC<Props> = (props) => (
  <ToastProvider>
    <SearchContainer {...props} />
  </ToastProvider>
);

const mapStateToProps = ({ prescription }: AppState): StateProps => ({
  error: prescription.error,
});

const mapDispatchToProps = {
  fetchPrescription: fetchPrescriptionAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainerWithToast);
